(() => {
  'use strict';

  const context = window.MGAnalyticsContext || {};
  const sent = new Map();

  function send(name, parameters = {}, dedupeKey = name, dedupeMs = 1200) {
    const now = Date.now();
    if (now - (sent.get(dedupeKey) || 0) < dedupeMs) return;
    sent.set(dedupeKey, now);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(argumentsForGtag('event', name, parameters));
  }

  function argumentsForGtag() {
    return arguments;
  }

  function productItem(variantId) {
    if (!context.product) return null;
    return {
      item_id: String(context.product.item_id || ''),
      item_name: context.product.item_name || '',
      item_brand: context.product.item_brand || '',
      item_category: context.product.item_category || '',
      item_variant: String(variantId || context.product.variant_id || ''),
      price: Number(context.product.price || 0),
      quantity: 1
    };
  }

  function ecommerceParameters(variantId) {
    const item = productItem(variantId);
    return item ? { currency: context.currency, value: item.price, items: [item] } : {};
  }

  if (context.product) {
    send('view_item', ecommerceParameters(), `view_item:${context.product.item_id}`, 30000);
  }

  document.addEventListener('teeinblue-event-after-cart-added', () => {
    send('add_to_cart', ecommerceParameters(), 'add_to_cart:tee');
    send('personalization_completed', { product_id: String(context.product?.item_id || '') }, 'personalization_completed');
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') return;
      send('add_to_cart', ecommerceParameters(event.productVariantId), `add_to_cart:${event.productVariantId || ''}`);
    });
  }

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], .shopify-payment-button__button');
    if (checkout) send('begin_checkout', {}, 'begin_checkout', 5000);

    const teeRoot = event.target.closest('#tee-artwork-form, [class*="tee-"]');
    if (teeRoot) {
      send('personalization_started', { product_id: String(context.product?.item_id || '') }, 'personalization_started', 30000);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'file' || !input.files?.length) return;
    if (!input.closest('#tee-artwork-form, [class*="tee-"]')) return;
    send('photo_selected', {
      product_id: String(context.product?.item_id || ''),
      file_count: input.files.length
    }, 'photo_selected', 1000);
  }, true);

  document.addEventListener('teeinblue-event-error', (event) => {
    send('personalization_error', {
      product_id: String(context.product?.item_id || ''),
      error_type: String(event.detail?.type || 'teeinblue')
    }, 'personalization_error', 1000);
  });

  document.addEventListener('mg:draft-save-opened', () => {
    send('draft_save_opened', { product_id: String(context.product?.item_id || '') }, 'draft_save_opened', 30000);
  });

  document.addEventListener('mg:draft-saved', () => {
    send('draft_saved', { product_id: String(context.product?.item_id || '') }, 'draft_saved', 5000);
  });

  document.addEventListener('mg:draft-survey-answered', (event) => {
    send('draft_survey_answered', {
      product_id: String(context.product?.item_id || ''),
      reason: String(event.detail?.reason || 'unknown')
    }, 'draft_survey_answered', 5000);
  });

  document.addEventListener('mg:draft-save-failed', () => {
    send('draft_save_failed', { product_id: String(context.product?.item_id || '') }, 'draft_save_failed', 5000);
  });
})();
